import React, { type ReactElement } from 'react';
import TranslateManager from 'ts-translate-js';
import type { AvailableMailingList } from '../../types/models/mvcapi/mailinglist';
import { UUID } from '../../types/basetypes';

const tr = TranslateManager.boundTR;
const trN = tr;

type MailingListsProps = {
    mailingLists: AvailableMailingList[];
    selectedMailingLists: UUID[];
    askCustomerForEmailAddressSharing: boolean;
    didAcceptEmailAddressSharing: boolean;
    handleMailingListSubscription: (mailingListId: string) => void;
    handleEmailSharingChoice: (checked: boolean) => void;
};
export function MailingLists({
    mailingLists,
    selectedMailingLists,
    askCustomerForEmailAddressSharing,
    didAcceptEmailAddressSharing,
    handleMailingListSubscription,
    handleEmailSharingChoice,
}: MailingListsProps): ReactElement {
    return <div>
        <h4>{trN("Infolettre", "Infolettres", { n: mailingLists.length })}</h4>
        <div className="well">
            {
                mailingLists.map((ml, i) => <div key={i} className="checkbox">
                    <strong>
                        <label>
                            <input type="checkbox" onChange={() => handleMailingListSubscription(ml.id)} checked={selectedMailingLists.includes(ml.id)} />
                            {ml.optinText.fr} {/* TODO: Use current lang here */}
                        </label>
                    </strong>
                </div>)
            }
            {
                askCustomerForEmailAddressSharing && <div className="checkbox">
                    <strong>
                        <label>
                            <input type="checkbox" onChange={() => handleEmailSharingChoice(!didAcceptEmailAddressSharing)} checked={didAcceptEmailAddressSharing} />
                            {tr("J'accepte que mon adresse courriel soit partagée aux producteurs pour l'inscription à des infolettres")}
                        </label>
                    </strong>
                </div>
            }
        </div>
    </div>;
}